import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "../CustomPagination";
import { GET_CUSTOMER_PROJECT_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function CustomerTable(props) {
  const { customerTab, setCustomerTab, valueTopTap } = props;
  const [sortedData, setSortedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "Name",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  // Function to format numbers
  const formatNumber = (number) => {
    return number.toString().padStart(2, "0");
  };

  console.log(sortedData, "sortedDatajuy65");

  // Handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Function to sort data
  const sortData = (data, key, direction) => {
    return data.sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  // Function to fetch customer project details
  const getCustomerprojectDetails = async (
    custId,
    sortKey = sortConfig.key,
    sortDirection = sortConfig.direction
  ) => {
    setLoading(true);
    let data = {
      customerId: customerTab?.customerId ? customerTab?.customerId : custId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_CUSTOMER_PROJECT_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        // const sorted = sortData(data, orderBy, order);
        console.log(data, "datataaaaaaaaaaaaaaaaa");
        setSortedData(data);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      setLoading(false);
    }
  };

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1);
  };

  // Fields to search in
  const fieldsToSearch = [
    "Name",
    "BillingPeriod",
    "MileageRate",
    "brokerCount",
  ];

  // Filter data based on search query
  const filteredData = sortedData.filter((item) =>
    fieldsToSearch.some((field) => {
      const fieldValue = item[field];
      return (
        fieldValue &&
        String(fieldValue).toLowerCase().includes(searchQuery.toLowerCase())
      );
    })
  );

  // Calculate paginated data
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    getCustomerprojectDetails(customerTab.custId);
  }, [customerTab.custId, order, orderBy]);

  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    // setSortClickedTime(new Date().toLocaleString());j

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  // Handle project navigation
  const handleProjectNavigate = (val) => {
    if (valueTopTap == "11") {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
      }));
    } else {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
      }));
    }
  };

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Name"}
                  direction={orderBy === "Name" ? order : "asc"}
                  onClick={() => handleSort("Name")}
                  IconComponent={() => getSortIcon("Name")}
                  style={orderBy === "Name" ? { color: "#007fff" } : {}}
                >
                  Projects
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "brokerCount"}
                  direction={orderBy === "brokerCount" ? order : "asc"}
                  onClick={() => handleSort("brokerCount")}
                  IconComponent={() => getSortIcon("brokerCount")}
                  style={orderBy === "brokerCount" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "brokerCount"}
                  // direction={
                  //   sortConfig.key === "brokerCount"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("brokerCount")}
                >
                  No of Brokers
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "MileageRate"}
                  direction={orderBy === "MileageRate" ? order : "asc"}
                  onClick={() => handleSort("MileageRate")}
                  IconComponent={() => getSortIcon("MileageRate")}
                  style={orderBy === "MileageRate" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "MileageRate"}
                  // direction={
                  //   sortConfig.key === "MileageRate"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("MileageRate")}
                >
                  Mileage Rate
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingPeriod"}
                  direction={orderBy === "BillingPeriod" ? order : "asc"}
                  onClick={() => handleSort("BillingPeriod")}
                  IconComponent={() => getSortIcon("BillingPeriod")}
                  style={
                    orderBy === "BillingPeriod" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingPeriod"}
                  // direction={
                  //   sortConfig.key === "BillingPeriod"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingPeriod")}
                >
                  Billing Period
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Active"}
                  direction={orderBy === "Active" ? order : "asc"}
                  onClick={() => handleSort("Active")}
                  IconComponent={() => getSortIcon("Active")}
                  style={orderBy === "Active" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Active"}
                  // direction={
                  //   sortConfig.key === "Active" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Active")}
                >
                  Active
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={
                      val.projID
                        ? {
                            color: "#007FFF !important",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }
                        : {}
                    }
                    onClick={() => handleProjectNavigate(val.projID)}
                  >
                    <span style={{ wordBreak: "break-word" }}>
                      {val.Name ? val.Name : "-"}
                    </span>
                  </TableCell>
                  <TableCell>
                    {val.brokerCount ? val.brokerCount : "0"}
                  </TableCell>
                  <TableCell>
                    ${val.MileageRate ? val.MileageRate?.toFixed(3) : "0.000"}
                  </TableCell>
                  <TableCell>
                    {val.BillingPeriod ? val.BillingPeriod : "-"}
                  </TableCell>
                  <TableCell sx={{ minWidth: "150px" }}>
                    <span
                      className={
                        val.Active === "Yes" ? "active-btn" : "inactive-btn"
                      }
                    >
                      {val.Active === "Yes" ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
